// 暴露 complete(sessionId) — 与 @/components/complete 同签名，方便 barrel 替换。
// 实际使用 ./index.tsx 的内部实现，customization/rootClass/antdToken 从 state.ts 读，
// 由 widget 的 login() 在打开抽屉时塞入。
import baseComplete from "./index";
import { completeContext } from "./state";

const complete = (sessionId: string) =>
  baseComplete(sessionId, {
    customization: completeContext.customization,
    rootClass: completeContext.rootClass,
    antdToken: completeContext.antdToken,
  });

export default complete;
